import { render, staticRenderFns } from "./ProductAddedToCart.vue?vue&type=template&id=8ea4bef0"
import script from "./ProductAddedToCart.vue?vue&type=script&lang=js"
export * from "./ProductAddedToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports